// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-plus-solid';

export const Component = () => (
  <path d='M24.521 3.921v3.927H0V3.921c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.288h4.934V1.48c0-.335.143-.479.479-.479.335 0 .478.144.478.479v1.484h10.824V1.48c0-.335.144-.479.479-.479.335 0 .479.144.479.479v1.484h4.933c.239 0 .478.096.67.288a.946.946 0 0 1 .287.67h.001ZM0 23.557V8.854h24.521v14.703c0 .24-.096.479-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67Zm8.813-7.376c0 .335.19.527.526.527h2.442v2.442c0 .335.144.479.48.479.334 0 .478-.144.478-.479v-2.442h2.442c.335 0 .527-.192.527-.527s-.192-.479-.527-.479H12.74V13.26c0-.335-.144-.479-.479-.479-.335 0-.479.144-.479.48v2.441H9.34c-.335 0-.527.144-.527.48Z' />
);

export const viewBox = '0 0 25 25';
